import React, { useState } from 'react';
import type { CoachPersona } from '../lib/personas';

type AvatarStackProps = {
  personas: CoachPersona[];
  selectedIds: string[];
  onToggle: (id: string) => void;
};

const AvatarStack: React.FC<AvatarStackProps> = ({ personas, selectedIds, onToggle }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const selected = personas.filter((p) => selectedIds.includes(p.id));
  const others = personas.filter((p) => !selectedIds.includes(p.id));

  return (
    <div className="relative flex items-center">
      <div
        className={`flex items-center transition-all duration-300 ease-in-out ${isExpanded ? 'space-x-2' : ''}`}
        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
      >
        {isExpanded && others.map((persona) => (
          <button
            key={persona.id}
            onClick={(e) => { e.stopPropagation(); onToggle(persona.id); }}
            className="transition-transform duration-200 hover:scale-105"
            aria-label={`Add ${persona.name}`}
            title={`Add ${persona.name}`}
          >
            <img
              src={`/coach-avatars/${persona.avatar}`}
              alt={persona.name}
              className="h-9 w-9 rounded-full border-2 border-white opacity-60 grayscale hover:opacity-100 hover:grayscale-0"
              loading="lazy"
            />
          </button>
        ))}
        <div className={`flex items-center ${isExpanded ? '' : 'space-x-[-14px]'}`}>
          {selected.map((persona) => (
            <button
              key={persona.id}
              onClick={(e) => { e.stopPropagation(); onToggle(persona.id); }}
              className="transition-transform duration-200 hover:scale-105"
              aria-label={`Remove ${persona.name}`}
              title={`Remove ${persona.name}`}
            >
              <img
                src={`/coach-avatars/${persona.avatar}`}
                alt={persona.name}
                className="h-9 w-9 rounded-full border-2 border-blue-500 shadow-sm"
                loading="lazy"
              />
            </button>
          ))}
        </div>
        <button
          type="button"
          className="ml-2 inline-flex items-center rounded-md border border-border px-2 py-0.5 text-[10px] font-medium text-muted-foreground hover:text-primary hover:border-primary sm:hidden"
          onClick={(e) => { e.stopPropagation(); setIsExpanded((v) => !v); }}
          aria-label="Edit active coaches"
          title="Edit coaches"
        >
          Edit
        </button>
      </div>
    </div>
  );
};

export default AvatarStack;
